import i18next, { type i18n } from 'i18next'
import { initReactI18next, useTranslation } from 'react-i18next'

import { ru, type Resources } from './locales/ru.js'

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'translation'
    resources: { translation: Resources }
  }
}

export const SUPPORTED_LOCALES = ['ru'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]

/** Инициализация i18n (синхронно: ресурсы встроены в бандл). Каркас: пока только ru. */
export function createI18n(locale: Locale = 'ru'): i18n {
  const instance = i18next.createInstance()
  void instance.use(initReactI18next).init({
    lng: locale,
    fallbackLng: 'ru',
    resources: { ru: { translation: ru } },
    interpolation: { escapeValue: false },
    initAsync: false,
    returnNull: false,
  })
  return instance
}

/** Локализованное имя из справочника: { ru: '…', en: '…' }. */
export function localize(
  name: Partial<Record<Locale, string>> | null | undefined,
  locale: Locale = 'ru',
): string {
  return name?.[locale] ?? name?.ru ?? Object.values(name ?? {})[0] ?? ''
}

export { I18nextProvider, Trans } from 'react-i18next'
export { useTranslation }
export { ru }
